/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CrmDemosRouteImport } from './routes/_crm-demos'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as WidgetsDemoRouteImport } from './routes/widgets-demo'
import { Route as CrmDemosAccountDetailsRouteImport } from './routes/_crm-demos/account-details'
import { Route as CrmDemosChartsDemoRouteImport } from './routes/_crm-demos/charts-demo'
import { Route as CrmDemosCrm1RouteImport } from './routes/_crm-demos/crm-1'
import { Route as CrmDemosCrm2RouteImport } from './routes/_crm-demos/crm-2'
import { Route as CrmDemosCrm3RouteImport } from './routes/_crm-demos/crm-3'
import { Route as CrmDemosCrm4RouteImport } from './routes/_crm-demos/crm-4'
import { Route as CrmDemosCrm5RouteImport } from './routes/_crm-demos/crm-5'
import { Route as CrmDemosCrm6RouteImport } from './routes/_crm-demos/crm-6'
import { Route as CrmDemosCrm7RouteImport } from './routes/_crm-demos/crm-7'
import { Route as CrmDemosCrm8RouteImport } from './routes/_crm-demos/crm-8'
import { Route as CrmDemosCrm9RouteImport } from './routes/_crm-demos/crm-9'
import { Route as CompetitorsIndexRouteImport } from './routes/competitors/index'
import { Route as CompetitorsIdRouteImport } from './routes/competitors/$id'
import { Route as CustomersIndexRouteImport } from './routes/customers/index'
import { Route as CustomersIdRouteImport } from './routes/customers/$id'
import { Route as DealsIndexRouteImport } from './routes/deals/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmDemosRoute = CrmDemosRouteImport.update({
  id: '/_crm-demos',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsRoute = ContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsRoute = LeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const WidgetsDemoRoute = WidgetsDemoRouteImport.update({
  id: '/widgets-demo',
  path: '/widgets-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmDemosAccountDetailsRoute = CrmDemosAccountDetailsRouteImport.update({
  id: '/account-details',
  path: '/account-details',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosChartsDemoRoute = CrmDemosChartsDemoRouteImport.update({
  id: '/charts-demo',
  path: '/charts-demo',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm1Route = CrmDemosCrm1RouteImport.update({
  id: '/crm-1',
  path: '/crm-1',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm2Route = CrmDemosCrm2RouteImport.update({
  id: '/crm-2',
  path: '/crm-2',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm3Route = CrmDemosCrm3RouteImport.update({
  id: '/crm-3',
  path: '/crm-3',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm4Route = CrmDemosCrm4RouteImport.update({
  id: '/crm-4',
  path: '/crm-4',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm5Route = CrmDemosCrm5RouteImport.update({
  id: '/crm-5',
  path: '/crm-5',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm6Route = CrmDemosCrm6RouteImport.update({
  id: '/crm-6',
  path: '/crm-6',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm7Route = CrmDemosCrm7RouteImport.update({
  id: '/crm-7',
  path: '/crm-7',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm8Route = CrmDemosCrm8RouteImport.update({
  id: '/crm-8',
  path: '/crm-8',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CrmDemosCrm9Route = CrmDemosCrm9RouteImport.update({
  id: '/crm-9',
  path: '/crm-9',
  getParentRoute: () => CrmDemosRoute,
} as any)
const CompetitorsIndexRoute = CompetitorsIndexRouteImport.update({
  id: '/competitors/',
  path: '/competitors/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompetitorsIdRoute = CompetitorsIdRouteImport.update({
  id: '/competitors/$id',
  path: '/competitors/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIndexRoute = CustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersIdRoute = CustomersIdRouteImport.update({
  id: '/customers/$id',
  path: '/customers/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsIndexRoute = DealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/leads': typeof LeadsRoute
  '/login': typeof LoginRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/widgets-demo': typeof WidgetsDemoRoute
  '/account-details': typeof CrmDemosAccountDetailsRoute
  '/charts-demo': typeof CrmDemosChartsDemoRoute
  '/crm-1': typeof CrmDemosCrm1Route
  '/crm-2': typeof CrmDemosCrm2Route
  '/crm-3': typeof CrmDemosCrm3Route
  '/crm-4': typeof CrmDemosCrm4Route
  '/crm-5': typeof CrmDemosCrm5Route
  '/crm-6': typeof CrmDemosCrm6Route
  '/crm-7': typeof CrmDemosCrm7Route
  '/crm-8': typeof CrmDemosCrm8Route
  '/crm-9': typeof CrmDemosCrm9Route
  '/competitors/$id': typeof CompetitorsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/competitors/': typeof CompetitorsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/deals/': typeof DealsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/leads': typeof LeadsRoute
  '/login': typeof LoginRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/widgets-demo': typeof WidgetsDemoRoute
  '/account-details': typeof CrmDemosAccountDetailsRoute
  '/charts-demo': typeof CrmDemosChartsDemoRoute
  '/crm-1': typeof CrmDemosCrm1Route
  '/crm-2': typeof CrmDemosCrm2Route
  '/crm-3': typeof CrmDemosCrm3Route
  '/crm-4': typeof CrmDemosCrm4Route
  '/crm-5': typeof CrmDemosCrm5Route
  '/crm-6': typeof CrmDemosCrm6Route
  '/crm-7': typeof CrmDemosCrm7Route
  '/crm-8': typeof CrmDemosCrm8Route
  '/crm-9': typeof CrmDemosCrm9Route
  '/competitors/$id': typeof CompetitorsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/competitors': typeof CompetitorsIndexRoute
  '/customers': typeof CustomersIndexRoute
  '/deals': typeof DealsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_crm-demos': typeof CrmDemosRouteWithChildren
  '/activity': typeof ActivityRoute
  '/analytics': typeof AnalyticsRoute
  '/campaigns': typeof CampaignsRoute
  '/contacts': typeof ContactsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/leads': typeof LeadsRoute
  '/login': typeof LoginRoute
  '/schedule': typeof ScheduleRoute
  '/settings': typeof SettingsRoute
  '/tasks': typeof TasksRoute
  '/widgets-demo': typeof WidgetsDemoRoute
  '/_crm-demos/account-details': typeof CrmDemosAccountDetailsRoute
  '/_crm-demos/charts-demo': typeof CrmDemosChartsDemoRoute
  '/_crm-demos/crm-1': typeof CrmDemosCrm1Route
  '/_crm-demos/crm-2': typeof CrmDemosCrm2Route
  '/_crm-demos/crm-3': typeof CrmDemosCrm3Route
  '/_crm-demos/crm-4': typeof CrmDemosCrm4Route
  '/_crm-demos/crm-5': typeof CrmDemosCrm5Route
  '/_crm-demos/crm-6': typeof CrmDemosCrm6Route
  '/_crm-demos/crm-7': typeof CrmDemosCrm7Route
  '/_crm-demos/crm-8': typeof CrmDemosCrm8Route
  '/_crm-demos/crm-9': typeof CrmDemosCrm9Route
  '/competitors/$id': typeof CompetitorsIdRoute
  '/customers/$id': typeof CustomersIdRoute
  '/competitors/': typeof CompetitorsIndexRoute
  '/customers/': typeof CustomersIndexRoute
  '/deals/': typeof DealsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/analytics'
    | '/campaigns'
    | '/contacts'
    | '/dashboard'
    | '/inventory'
    | '/leads'
    | '/login'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/widgets-demo'
    | '/account-details'
    | '/charts-demo'
    | '/crm-1'
    | '/crm-2'
    | '/crm-3'
    | '/crm-4'
    | '/crm-5'
    | '/crm-6'
    | '/crm-7'
    | '/crm-8'
    | '/crm-9'
    | '/competitors/$id'
    | '/customers/$id'
    | '/competitors/'
    | '/customers/'
    | '/deals/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/analytics'
    | '/campaigns'
    | '/contacts'
    | '/dashboard'
    | '/inventory'
    | '/leads'
    | '/login'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/widgets-demo'
    | '/account-details'
    | '/charts-demo'
    | '/crm-1'
    | '/crm-2'
    | '/crm-3'
    | '/crm-4'
    | '/crm-5'
    | '/crm-6'
    | '/crm-7'
    | '/crm-8'
    | '/crm-9'
    | '/competitors/$id'
    | '/customers/$id'
    | '/competitors'
    | '/customers'
    | '/deals'
  id:
    | '__root__'
    | '/'
    | '/_crm-demos'
    | '/activity'
    | '/analytics'
    | '/campaigns'
    | '/contacts'
    | '/dashboard'
    | '/inventory'
    | '/leads'
    | '/login'
    | '/schedule'
    | '/settings'
    | '/tasks'
    | '/widgets-demo'
    | '/_crm-demos/account-details'
    | '/_crm-demos/charts-demo'
    | '/_crm-demos/crm-1'
    | '/_crm-demos/crm-2'
    | '/_crm-demos/crm-3'
    | '/_crm-demos/crm-4'
    | '/_crm-demos/crm-5'
    | '/_crm-demos/crm-6'
    | '/_crm-demos/crm-7'
    | '/_crm-demos/crm-8'
    | '/_crm-demos/crm-9'
    | '/competitors/$id'
    | '/customers/$id'
    | '/competitors/'
    | '/customers/'
    | '/deals/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CrmDemosRoute: typeof CrmDemosRouteWithChildren
  ActivityRoute: typeof ActivityRoute
  AnalyticsRoute: typeof AnalyticsRoute
  CampaignsRoute: typeof CampaignsRoute
  ContactsRoute: typeof ContactsRoute
  DashboardRoute: typeof DashboardRoute
  InventoryRoute: typeof InventoryRoute
  LeadsRoute: typeof LeadsRoute
  LoginRoute: typeof LoginRoute
  ScheduleRoute: typeof ScheduleRoute
  SettingsRoute: typeof SettingsRoute
  TasksRoute: typeof TasksRoute
  WidgetsDemoRoute: typeof WidgetsDemoRoute
  CompetitorsIdRoute: typeof CompetitorsIdRoute
  CustomersIdRoute: typeof CustomersIdRoute
  CompetitorsIndexRoute: typeof CompetitorsIndexRoute
  CustomersIndexRoute: typeof CustomersIndexRoute
  DealsIndexRoute: typeof DealsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_crm-demos': {
      id: '/_crm-demos'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CrmDemosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads': {
      id: '/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof LeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/widgets-demo': {
      id: '/widgets-demo'
      path: '/widgets-demo'
      fullPath: '/widgets-demo'
      preLoaderRoute: typeof WidgetsDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_crm-demos/account-details': {
      id: '/_crm-demos/account-details'
      path: '/account-details'
      fullPath: '/account-details'
      preLoaderRoute: typeof CrmDemosAccountDetailsRouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/charts-demo': {
      id: '/_crm-demos/charts-demo'
      path: '/charts-demo'
      fullPath: '/charts-demo'
      preLoaderRoute: typeof CrmDemosChartsDemoRouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-1': {
      id: '/_crm-demos/crm-1'
      path: '/crm-1'
      fullPath: '/crm-1'
      preLoaderRoute: typeof CrmDemosCrm1RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-2': {
      id: '/_crm-demos/crm-2'
      path: '/crm-2'
      fullPath: '/crm-2'
      preLoaderRoute: typeof CrmDemosCrm2RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-3': {
      id: '/_crm-demos/crm-3'
      path: '/crm-3'
      fullPath: '/crm-3'
      preLoaderRoute: typeof CrmDemosCrm3RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-4': {
      id: '/_crm-demos/crm-4'
      path: '/crm-4'
      fullPath: '/crm-4'
      preLoaderRoute: typeof CrmDemosCrm4RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-5': {
      id: '/_crm-demos/crm-5'
      path: '/crm-5'
      fullPath: '/crm-5'
      preLoaderRoute: typeof CrmDemosCrm5RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-6': {
      id: '/_crm-demos/crm-6'
      path: '/crm-6'
      fullPath: '/crm-6'
      preLoaderRoute: typeof CrmDemosCrm6RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-7': {
      id: '/_crm-demos/crm-7'
      path: '/crm-7'
      fullPath: '/crm-7'
      preLoaderRoute: typeof CrmDemosCrm7RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-8': {
      id: '/_crm-demos/crm-8'
      path: '/crm-8'
      fullPath: '/crm-8'
      preLoaderRoute: typeof CrmDemosCrm8RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/_crm-demos/crm-9': {
      id: '/_crm-demos/crm-9'
      path: '/crm-9'
      fullPath: '/crm-9'
      preLoaderRoute: typeof CrmDemosCrm9RouteImport
      parentRoute: typeof CrmDemosRoute
    }
    '/competitors/': {
      id: '/competitors/'
      path: '/competitors'
      fullPath: '/competitors/'
      preLoaderRoute: typeof CompetitorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/competitors/$id': {
      id: '/competitors/$id'
      path: '/competitors/$id'
      fullPath: '/competitors/$id'
      preLoaderRoute: typeof CompetitorsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/': {
      id: '/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof CustomersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers/$id': {
      id: '/customers/$id'
      path: '/customers/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof CustomersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals/': {
      id: '/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof DealsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CrmDemosRouteChildren {
  CrmDemosAccountDetailsRoute: typeof CrmDemosAccountDetailsRoute
  CrmDemosChartsDemoRoute: typeof CrmDemosChartsDemoRoute
  CrmDemosCrm1Route: typeof CrmDemosCrm1Route
  CrmDemosCrm2Route: typeof CrmDemosCrm2Route
  CrmDemosCrm3Route: typeof CrmDemosCrm3Route
  CrmDemosCrm4Route: typeof CrmDemosCrm4Route
  CrmDemosCrm5Route: typeof CrmDemosCrm5Route
  CrmDemosCrm6Route: typeof CrmDemosCrm6Route
  CrmDemosCrm7Route: typeof CrmDemosCrm7Route
  CrmDemosCrm8Route: typeof CrmDemosCrm8Route
  CrmDemosCrm9Route: typeof CrmDemosCrm9Route
}

const CrmDemosRouteChildren: CrmDemosRouteChildren = {
  CrmDemosAccountDetailsRoute: CrmDemosAccountDetailsRoute,
  CrmDemosChartsDemoRoute: CrmDemosChartsDemoRoute,
  CrmDemosCrm1Route: CrmDemosCrm1Route,
  CrmDemosCrm2Route: CrmDemosCrm2Route,
  CrmDemosCrm3Route: CrmDemosCrm3Route,
  CrmDemosCrm4Route: CrmDemosCrm4Route,
  CrmDemosCrm5Route: CrmDemosCrm5Route,
  CrmDemosCrm6Route: CrmDemosCrm6Route,
  CrmDemosCrm7Route: CrmDemosCrm7Route,
  CrmDemosCrm8Route: CrmDemosCrm8Route,
  CrmDemosCrm9Route: CrmDemosCrm9Route,
}

const CrmDemosRouteWithChildren = CrmDemosRoute._addFileChildren(
  CrmDemosRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CrmDemosRoute: CrmDemosRouteWithChildren,
  ActivityRoute: ActivityRoute,
  AnalyticsRoute: AnalyticsRoute,
  CampaignsRoute: CampaignsRoute,
  ContactsRoute: ContactsRoute,
  DashboardRoute: DashboardRoute,
  InventoryRoute: InventoryRoute,
  LeadsRoute: LeadsRoute,
  LoginRoute: LoginRoute,
  ScheduleRoute: ScheduleRoute,
  SettingsRoute: SettingsRoute,
  TasksRoute: TasksRoute,
  WidgetsDemoRoute: WidgetsDemoRoute,
  CompetitorsIdRoute: CompetitorsIdRoute,
  CustomersIdRoute: CustomersIdRoute,
  CompetitorsIndexRoute: CompetitorsIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  DealsIndexRoute: DealsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
